<template>
  <a-col :sm="{ span: 24 }" :md="{ span: 8 }" class="gutter-row">
    <div style="background:#FFF;">
      <a-card :bordered="false">
        <a-popconfirm title="Are you sure to delete server?" placement="top" okText="Yes" cancelText="No" @confirm="confirm">
          <a-icon
            :style="{color:'darkred',padding: '5px', fontSize: '1.2em;', cursor: 'pointer', position: 'absolute', right: '1px', top: '2px'}"
            type="close-circle"
          />
        </a-popconfirm>
        <a-row>
          <a-col :span="16">
            <a-icon :style="{color:'#00D900',padding: '5px'}" type="info-circle"/>
            <span :style="{color:'#00D900'}">{{info.availability}} Availability</span>

            <h2>
              <router-link :to="{ name:'serverdetails', params: {key: info.api_key, server: info.id} }">{{info.name}}</router-link>
            </h2>

            <a-row>
              <a-col :span="12">{{info.ipv4}}</a-col>
            </a-row>
          </a-col>
          <a-col :span="8">
            <span>{{timeAgo(info.update_time)}}</span>
          </a-col>
        </a-row>
        <hr>
        <a-row>
          <span>Load</span>
          <a-tooltip :title="`Load ${info.load_average}`">
            <a-progress :percent="info.load_percent"
              :status="info.load_percent > 80 ? 'exception' : 'active'"/>
          </a-tooltip>

          <span>RAM</span>
          <a-tooltip
            :title="`RAM ${parseInt(info.ram_usage /1049000)} MB / ${parseInt(info.ram_total /1049000)} MB (${parseResultWithPercentage(info.ram_usage, info.ram_total)}%)`"
          >
            <a-progress
                :percent="parseResultWithPercentage(info.ram_usage, info.ram_total)"
                :status="parseResultWithPercentage(info.ram_usage, info.ram_total) > 80 ? 'exception' : 'active'"/>
          </a-tooltip>
          <span>Disk</span>
          <a-tooltip
            :title="`DISK ${parseFloat(info.disk_usage /1074176000).toFixed(2)} GB / ${parseInt(info.disk_total /1074176000)} GB (${parseResultWithPercentage(info.disk_usage, info.disk_total)}%)`"
          >
            <a-progress
                :percent="parseResultWithPercentage(info.disk_usage, info.disk_total)"
                :status="parseResultWithPercentage(info.disk_usage, info.disk_total) > 80 ? 'exception' : 'active'"
            />
          </a-tooltip>
        </a-row>
      </a-card>
    </div>
  </a-col>
</template>
<script>
import moment from "moment";
export default {
  props: {
    info: {}
  },
  methods: {
    timeAgo(time) {
      return moment.unix(time).fromNow();
    },
    parseResultWithPercentage(input1, input2) {
      return parseInt(input1 / input2 * 100);
    },
    confirm() {
      this.$emit('remove', { key: this.info.api_key, id: this.info.id });
    }
  }
};
</script>

